// PickingRoutesXL - Sprint 44 Fase 3 Vista 7.
// Reemplaza modules/picking/routes.jsx. Rutas preservadas:
// /picking (index), /picking/:id (scan).
import { Routes, Route } from 'react-router-dom';
import PickingsListXL from './PickingsListXL';
import PickingScanXL from './PickingScanXL';

export default function PickingRoutesXL() {
  return (
    <Routes>
      <Route index element={<PickingsListXL />} />
      <Route path=":id" element={<PickingScanXL />} />
    </Routes>
  );
}
